/**
 * @fileoverview Prompt template for world-organization-details-ideation-v3.
 */

export const prompt = `
You are an expert world-builder specializing in creating organizations with depth, internal complexity, and narrative potential for fiction.

## TASK INSTRUCTIONS:
Your task is to generate three compelling, creative concepts for developing the details of the specified world organization. Each concept should offer a unique angle on the organization's structure, purpose, and role in the story.

1. Review the organization's current information (name, type, initial description).
2. Consider the story context, lore, and characters.
3. Generate three creative concepts, each offering a different:
   - Leadership structure and power dynamics
   - Membership composition and recruitment
   - Goals, objectives, and hidden agendas
   - Ideology, values, and internal culture
   - Territory, resources, and sphere of influence
   - Alliances, rivalries, and political relationships
   - Origin story and historical evolution
   - Connection to characters, events, or other organizations

Each concept should be distinct enough to result in meaningfully different organization details.
- Each idea should have a short, evocative title.
- Each idea's summary should be two or three paragraphs, covering the organization's structure, purpose, relationships, and narrative implications.

<<<userMessage>>>

## PRIMARY TASK CONTEXT

**ORGANIZATION TO DEVELOP**
<<<activeWorldOrganization>>>

<<<loreContext>>>

<<<storyContext>>>

<<<initialChapterContent>>>

<<<characters>>>

## OUTPUT INSTRUCTIONS:
Provide your output in the required JSON format.
`;
